import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListUsers from '../../admin/list-users';
import Header from '../../common/components/header';
import Sidebar from '../../common/components/sidebar';
import ContactRequests from '../../../feature-module/admin/contact-requests/contact-requests';

const AdminRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/list-users" element={<ListUsers />} />
            <Route path="/contact-requests" element={<ContactRequests />} />
          </Routes>
        </div>
      </div>
      
    </>
  );
};

export default AdminRoutes;
